import React from 'react';
import { View, Picker } from 'react-native';
import DataTable from '@preflighttech/preflight-tables';
import moment from 'moment';

import { StyledPicker } from 'app/src/elements/inputs';
import {
  DownloadButton,
  downloadReport,
} from 'app/src/elements/ReportDownload';
import { Text } from 'app/src/styles';

import { USER_SCOPES } from './index';

const RegisteredBidders = ({ saleId, buyerUsers, scope, setScope, saleBuyerUsers }) => {
  const columns = [
    {
      key: 'fullName',
      label: 'Name',
    },
    {
      key: 'paddleNumber',
      label: 'Paddle #',
    },
    {
      key: 'companyName',
      label: 'Company Name',
      value: ({ entry }) => entry.buyer.companyName || entry.buyer.name,
    },
    {
      key: 'cityState',
      label: 'City',
      value: ({ entry }) => entry.buyer.cityState,
    },
    {
      key: 'siteRegistered',
      label: 'Site Registered',
      hidden: scope !== 'sale_registered',
      value: ({ entry }) => entry.createdAt ?
        moment(entry.createdAt).format('MM-DD-YY \@ hh:mmA') :
        ''
    },
    {
      key: 'saleRegistered',
      label: 'Sale Registered',
      hidden: scope !== 'sale_registered',
      value: ({ entry }) => {
        let user = saleBuyerUsers.find(saleBuyerUser => saleBuyerUser.buyerUser.id === entry.id)
        return moment(user?.createdAt).format('MM-DD-YY \@ hh:mmA')
      }
    }
  ];

  const scopeLabel = scope ?
    USER_SCOPES.find(({ value }) => value === scope).label : '';

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'sale-buyer-users-report',
      params: { scope, scopeLabel, 'sale-id': saleId }
    })
  };

  const buttons = setScope ? (
    <View
      style={{
        flexDirection: 'row',
        marginBottom: 20,
        gap: 20,
        alignItems: 'baseline',
      }}
    >
      <Text>Filter:</Text>
      <StyledPicker value={scope} onValueChange={value => setScope(value)}>
        {USER_SCOPES.map(option => (
          <Picker.Item key={option.value} {...option} />
        ))}
      </StyledPicker>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  ) : null;

  return (
    <View>

      <DataTable.Simple
        data={buyerUsers}
        columns={columns}
        pageLength="All"
        htmlTable
        sortOnArrowClickOnly
        buttons={buttons}
      />
    </View>
  );
};

export default RegisteredBidders;
